import React from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { PROJECTS } from "../lib/portfolioData";

export default function Portfolio() {
  return (
    <div>
      <section className="hero-blue py-20 px-5">
        <div className="max-w-4xl mx-auto text-center">
          <h1 className="text-5xl sm:text-6xl font-extrabold text-white" style={{fontFamily:'Outfit'}}>
            Our <span style={{color:'var(--accent-yellow)'}}>Portfolio</span>
          </h1>
          <p className="text-blue-100 mt-4 text-lg">Case studies of real businesses we've helped grow.</p>
        </div>
      </section>

      <section className="py-16 px-5">
        <div className="max-w-6xl mx-auto grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {PROJECTS.map((p, i) => (
            <motion.div
              key={p.slug}
              initial={{opacity:0, y:20}} whileInView={{opacity:1, y:0}} viewport={{once:true}}
              transition={{duration:.4, delay:i*0.05}}
              className="card overflow-hidden group"
              data-testid={`portfolio-card-${i}`}
            >
              <Link to={`/portfolio/${p.slug}`} className="block">
                <div className="relative aspect-[16/10] overflow-hidden">
                  <img src={p.image} alt={p.title} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" loading="lazy"/>
                  <div className="absolute inset-0 bg-gradient-to-t from-slate-900/85 to-transparent" />
                  <span className="absolute top-3 left-3 tag !bg-blue-600 !text-white !border-blue-600">{p.tag}</span>
                  <div className="absolute bottom-3 left-3 right-3 flex items-end justify-between">
                    <div className="text-xs uppercase tracking-[0.18em] text-blue-300 font-semibold">{p.category}</div>
                    <div className="text-xs px-2.5 py-1 rounded-full bg-emerald-500/15 text-emerald-300 border border-emerald-500/30 font-semibold">{p.impact}</div>
                  </div>
                </div>
                <div className="p-6">
                  <h3 className="text-xl font-bold text-white flex items-center justify-between gap-2" style={{fontFamily:'Outfit'}}>
                    {p.title}
                    <ArrowUpRight size={18} className="text-blue-400 opacity-0 group-hover:opacity-100 transition-opacity"/>
                  </h3>
                  <p className="text-slate-400 mt-2 text-sm leading-relaxed">{p.desc}</p>
                  <span className="mt-4 inline-block text-blue-400 text-sm font-semibold">View case study →</span>
                </div>
              </Link>
            </motion.div>
          ))}
        </div>
        <div className="text-center mt-14">
          <Link to="/contact" className="btn-primary">Start your project</Link>
        </div>
      </section>
    </div>
  );
}
